<div class="ph-chart">
  <canvas
    baseChart
    width="400"
    height="400"
    #canvasChart
    [datasets]="lineChartData"
    [labels]="lineChartLabels"
    [options]="lineChartOptions"
    [colors]="lineChartColors"
    [legend]="lineChartLegend"
    [chartType]="lineChartType"
    [plugins]="lineChartPlugins"
  >
  </canvas>
</div>
